import { render, staticRenderFns } from "./AdminHeader.vue?vue&type=template&id=5a8ac0c9&scoped=true&"
import script from "./AdminHeader.vue?vue&type=script&lang=js&"
export * from "./AdminHeader.vue?vue&type=script&lang=js&"
import style0 from "styles/components/adminHeader.css?vue&type=style&index=0&id=5a8ac0c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8ac0c9",
  null
  
)

export default component.exports